export default __webpack_public_path__ + "0bf5316465abef7f2c9da6f700f9b4c3.svg";